/**
 * options for DynamicHTMLModule
 */
var DynamicHTMLOptions = (function () {
    function DynamicHTMLOptions() {
    }
    return DynamicHTMLOptions;
}());
export { DynamicHTMLOptions };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/ng-dynamic/src/dynamic-html/options.js
// module id = ../../../../ng-dynamic/src/dynamic-html/options.js
// module chunks = 3